import { http } from '../../../../api/http';
import type { Asistencia, Incidencia, ResumenAsistenciaPeriodo, ResumenAsistenciaTrabajador } from '../types/asistencia';

const ENDPOINT = '/planilla/asistencia';

export class AsistenciaService {
  static async getByPeriodo(idPeriodo: number, idTrabajador?: number): Promise<Asistencia[]> {
    const params: Record<string, number> = {};
    if (idTrabajador) params.idTrabajador = idTrabajador;
    const response = await http.get(`${ENDPOINT}/periodo/${idPeriodo}`, { params });
    return response.data;
  }

  static async registrar(asistencia: Partial<Asistencia>): Promise<Asistencia> {
    const response = await http.post(ENDPOINT, asistencia);
    return response.data;
  }

  static async registrarMasiva(idPeriodo: number, idTrabajadores: number[]): Promise<{ registrosCreados: number }> {
    const response = await http.post(`${ENDPOINT}/masiva`, { idPeriodo, idTrabajadores });
    return response.data;
  }

  static async update(id: number, asistencia: Partial<Asistencia>): Promise<Asistencia> {
    const response = await http.put(`${ENDPOINT}/${id}`, asistencia);
    return response.data;
  }

  static async delete(id: number): Promise<void> {
    await http.delete(`${ENDPOINT}/${id}`);
  }

  // Incidencias
  static async getIncidencias(idPeriodo: number, idTrabajador?: number): Promise<Incidencia[]> {
    const params: Record<string, number> = {};
    if (idTrabajador) params.idTrabajador = idTrabajador;
    const response = await http.get(`${ENDPOINT}/incidencia/periodo/${idPeriodo}`, { params });
    return response.data;
  }

  static async registrarIncidencia(incidencia: Partial<Incidencia>): Promise<Incidencia> {
    const response = await http.post(`${ENDPOINT}/incidencia`, incidencia);
    return response.data;
  }

  static async updateIncidencia(id: number, incidencia: Partial<Incidencia>): Promise<Incidencia> {
    const response = await http.put(`${ENDPOINT}/incidencia/${id}`, incidencia);
    return response.data;
  }

  static async deleteIncidencia(id: number): Promise<void> {
    await http.delete(`${ENDPOINT}/incidencia/${id}`);
  }

  // Recalcular horas
  static async recalcularHoras(idPeriodo: number): Promise<{ registrosActualizados: number }> {
    const response = await http.post(`${ENDPOINT}/recalcular-horas/${idPeriodo}`);
    return response.data;
  }

  // Resumen
  static async getResumen(idPeriodo: number): Promise<ResumenAsistenciaPeriodo> {
    const response = await http.get(`${ENDPOINT}/resumen/${idPeriodo}`);
    return response.data;
  }

  static async getResumenTrabajador(idPeriodo: number, idTrabajador: number): Promise<ResumenAsistenciaTrabajador> {
    const response = await http.get(`${ENDPOINT}/resumen/${idPeriodo}/trabajador/${idTrabajador}`);
    return response.data;
  }
}
